var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "styled-components";
import Theme from "../components/react-components/Styles/Theme";
import { Container, FiltersContainer, ContentContainer } from "../components/react-components/shared-components/Ui/Grid/Grid";
import { FilterCard } from "../components/react-components/shared-components/SideFilter/FilterCard";
import { Filters } from "../components/react-components/doc-lib-components/Filters";
import { View } from "../components/react-components/doc-lib-components/Views/View";
import { CleanFilters } from "../components/react-components/doc-lib-components/CleanFilters";
import { Title } from "../components/react-components/shared-components/Title/Title";
import { SearchBar } from "../components/react-components/doc-lib-components/SearchBar";
import { InfoBar } from "../components/react-components/doc-lib-components/InfoBar";
import { DocLibProvider } from "./Context/DocLibContext";
import { PageLoading } from "./../components/react-components/shared-components/Loading/PageLoading";
import { Pagination } from "../components/react-components/doc-lib-components/Pagination";
import GlobalStyles from "../components/react-components/Styles/Global";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import i18n from "../i18n/i18n";
export var DocsLib = function () {
    React.useEffect(function () {
        var _a;
        // @ts-ignore
        var langCode = ((_a = document.getElementById("language-code")) === null || _a === void 0 ? void 0 : _a.value) || "en";
        if ((langCode === null || langCode === void 0 ? void 0 : langCode.length) === 2) {
            i18next.changeLanguage(langCode);
        }
    }, []);
    return (_jsx(Suspense, __assign({ fallback: _jsx(PageLoading, {}) }, { children: _jsx(I18nextProvider, __assign({ i18n: i18n }, { children: _jsx(DocLibProvider, { children: _jsxs(ThemeProvider, __assign({ theme: Theme }, { children: [_jsx(GlobalStyles, {}), _jsx("div", __assign({ className: "pg-documents" }, { children: _jsxs(Container, { children: [_jsxs(FiltersContainer, { children: [_jsx(SearchBar, {}), _jsxs(FilterCard, { children: [_jsx(CleanFilters, {}), _jsx(Filters, {})] })] }), _jsxs(ContentContainer, { children: [_jsx(Title, { title: "Biblioth\u00E8que de documentation" }), _jsx(InfoBar, {}), _jsx(View, {}), _jsx(Pagination, {})] })] }) }))] })) }) })) })));
};
var domNode = document.querySelector("#docs-lib");
if (domNode) {
    var root = createRoot(domNode);
    root.render(_jsx(DocsLib, {}));
}
